export const getIsniSuccessMessage = (
  statusCode: number,
  isPreferredIsniSet: boolean
) => {
  if (statusCode === 200) {
    return 'ISNI has already been added';
  }
  if (statusCode === 201 && isPreferredIsniSet) {
    return 'ISNI Number has been added';
  }
  return 'ISNI successfully added, you can now set a default';
};
